module.exports = __webpack_public_path__ + "static/image-03-b@2x-fa07a57d344bdac4cacf09a29efd9330.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/yieldr/image-03-b@2x.jpg
// module id = 429
// module chunks = 3627797113349 20562973939449 33019919093843